import { Box, TextField } from "@mui/material";
import { LoadingButton } from "../../../components/button/Button";
import {
  useAddCategoryExpense,
  useGetDetailCategoryExpense,
  useUpdateCategoryExpense,
} from "../network/resolver";
import { useEffect, useState } from "react";
import Spinner from "../../../components/spinner/Spinner";

interface ExpenseCategoryFormProps {
  id?: any;
}

export default function ExpenseCategoryForm({ id }: ExpenseCategoryFormProps) {
  const { data: dataRawDetailExpenseCategory, isLoading: loadingFetch } =
    useGetDetailCategoryExpense({
      expense_category_id: id,
    });
  const dataDetailExpenseCategory = dataRawDetailExpenseCategory?.data.data;
  const { mutate: mutateAdd, isLoading: loadingAdd } = useAddCategoryExpense();
  const { mutate: mutateUpdate, isLoading: loadingUpdate } =
    useUpdateCategoryExpense();
  const [name, setName] = useState("");
  const isLoading = loadingAdd || loadingUpdate;

  useEffect(() => {
    if (dataDetailExpenseCategory) {
      setName(dataDetailExpenseCategory?.name);
    }
  }, [dataDetailExpenseCategory]);

  const handleOnClick = () => {
    if (id) {
      mutateUpdate({ name, expense_category_id: id });
    } else {
      mutateAdd({ name });
    }
  };

  if (loadingFetch) {
    return <Spinner />;
  }

  return (
    <Box>
      <TextField
        fullWidth
        label="Nama"
        placeholder="Nama"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <Box display={"flex"} justifyContent={"flex-end"} mt={2}>
        <LoadingButton
          onClick={handleOnClick}
          text="Submit"
          isLoading={isLoading}
        />
      </Box>
    </Box>
  );
}
